import React from 'react';
import { NavLink } from 'react-router-dom';

export function LandingPage() {
    return (
        <>
            <div className='landing-page-container'>
                <header className='header'>
                    <img src={require('./../imgs/loyaltea-logo.png')} alt='Loyaltea logo' className='header-logo' />
                    <h1>Loyaltea</h1>
                </header>

                <section className='main-cta'>
                    <h2>Join the Waitlist!</h2>
                    <p>India's first Unified Loyalty Network (ULN) — one network for loyalty and discovery.</p>
                    <p>Create custom loyalty programs and share coupons within your network — no competition, no commissions.</p>
                    <p>Officially launching on <br /> 26 January, 2026</p>
                    <NavLink to='/form' className="nav-link"><button id='main-cta-button'>Join the Waitlist</button></NavLink>
                    <img src={require('./../imgs/main-cta-image.png')} alt='Loyaltea in use' className='main-cta-image' />
                </section>

                <section className='benefits'>
                    <div className='benefits-item'>
                        <h2>Discover a new approach to</h2>
                        <h2>customer retention and discovery.</h2>

                        <h3>Why Unified Loyalty Network Matters</h3>
                        <p>Our Unified Loyalty Network helps businesses create private groups with other businesses. Each business can set up its own loyalty program and share coupons within the group. When a customer visits one business, they automatically get offers from other businesses and are added to their loyalty programs. There are no commissions, and businesses can onboard unlimited customers and share unlimited coupons—growing together instead of competing.</p>

                        <h3>Getting more customers</h3>
                        <p>Discover how building your own loyalty network helps turn one-time visitors into regulars—while also bringing new customers to your business without relying on aggregators or marketplaces.</p>

                        <h3>Preventing excess spend on ads and commission</h3>
                        <p>Learn how a Unified Loyalty Network reduces dependence on rising commissions and paid ads, helping you grow customer discovery and retention without overspending.</p>

                        <NavLink to='/form' className="nav-link"><button id='main-cta-button'>Join the Waitlist</button></NavLink>
                    </div>
                </section>

                <section className='beta-testing'>
                    <img src={require('./../imgs/la-milano-logo.png')} alt='La Milano logo' className='la-milano-logo' />
                    <p>Currently in beta across select La Milano locations in India, delivering up to 400% ROI.</p>
                </section>

                <section className='about-us'>
                    <h2>About us</h2>
                    <div className='about-us-item'>
                        <img src={require('./../imgs/about-us-image.png')} alt='People working together' className='about-us-image' />
                        <p>Our team brings experience from building and scaling systems at global companies like Starbucks and Oracle. We’re applying those learnings to reimagine loyalty and customer discovery—through smaller, collaborative networks designed for sustainable growth.</p>
                    </div>
                </section>

                <section className='secondary-cta'>
                    <img src={require('./../imgs/join.png')} alt='Join icon' className='join-icon-image' />
                    <p>Join the waitlist for early access, priority onboarding, and exclusive updates. You can also invite another business owner to start building your private network ahead of launch.</p>
                    <NavLink to='/form' className="nav-link"><button id='secondary-cta-button'>Join the Waitlist</button></NavLink>
                </section>

                <footer className='footer'>
                    <img src={require('./../imgs/loyaltea-logo.png')} alt='Loyaltea logo' className='footer-image' />
                    <p>© Loyaltea</p>
                </footer>
            </div>
        </>
    )
}